// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-gray[data-v-519bd6b5] {\r\n  color: #909090;\r\n  font-weight: 100;\n}\n.left-border-none[data-v-519bd6b5] {\r\n  border-left: 4px solid #f7f7f7;\r\n  border-radius: 6px;\r\n  height: 100%;\r\n  width: 100px;\r\n  position: absolute;\r\n  top: 0;\r\n  left: -20px;\n}\n.top-1[data-v-519bd6b5] {\r\n  position: absolute;\r\n  top: 10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
